import {registerReactPartial} from '@github-ui/react-core/register-partial'
import {KeyboardShortcutsDialog} from './KeyboardShortcutsDialog'

registerReactPartial('keyboard-shortcuts-dialog', {
  Component: KeyboardShortcutsDialog,
})
